import React from "react"
import { TextField } from "@mui/material"
import i18n from "@/i18n"

interface TimeRangeInputProps {
  startTime: string
  endTime: string
  disabled?: boolean
  onStartTimeChange: (value: string) => void
  onEndTimeChange: (value: string) => void
}

const TimeRangeInput: React.FC<TimeRangeInputProps> = ({
  startTime,
  endTime,
  disabled = false,
  onStartTimeChange,
  onEndTimeChange,
}) => {
  return (
    <div
      className="flex items-center gap-2 flex-1 justify-end"
      style={{ opacity: disabled ? 0.4 : 1 }}
      data-testid="settings-venue-hours-time-range"
    >
      <TextField
        type="time"
        size="small"
        className="w-32"
        value={startTime}
        onChange={(e) => onStartTimeChange(e.target.value)}
        disabled={disabled}
        data-testid="settings-venue-hours-time-range-input-start"
      />
      <span className="text-gray-600">{i18n.t("app.settings.venues.opening_hours.to")}</span>
      <TextField
        type="time"
        size="small"
        className="w-32"
        value={endTime}
        onChange={(e) => onEndTimeChange(e.target.value)}
        disabled={disabled}
        data-testid="settings-venue-hours-time-range-input-end"
      />
    </div>
  )
}

export default TimeRangeInput
